<div class="searchbox">
  <div
    class="px-2 py-2 bg-white rounded-4 border border-1 border-secondary align-items-center">
    <div class="row">
      <div class="position-relative col-1 py-2 object-fit-contain">
        <img src="../../../../assets/images/search-lg.svg" alt="" />
      </div>
      <div class="col-10 text-start">
        <input
          #search
          type="text"
          class="text-dark fs-6 fw-normal py-2 border-0 form-control"
          placeholder="{{ 'Search service name' | translate }}"
          (keyup)="onKeyUp()"
          (focus)="setFocus(1)"
          (blur)="setFocus(0)"
          [value]="value"
          (keydown.enter)="onEnter()" />
        <div class="col-1">
          @if (search.value) {
          <span class="clear-search" (click)="search.value = ''">
            {{ 'Clear' | translate }}
          </span>
          } @if (isSearching) {
          <span class="searching">
            <div
              class="spinner-border text-bg-irembo-blue spinner-border-sm"
              role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </span>
          }
        </div>
      </div>
      @if (search.value && focused) {
      <ul class="predictions position-absolute py-2 px-0 list-unstyled">
        @for (result of searchResults; track result) {
        <li class="px-4" (mousedown)="handleSelect(result)">
          <span> {{ result.serviceName | translate }} </span>
          <small class="badge text-bg-secondary ms-2">{{
            result.organization.name | translate
          }}</small>
        </li>
        }
      </ul>
      }
    </div>
  </div>
</div>
